import { L } from '@lib';
import { IOption } from '@models';
import { Select } from 'antd';
import React from 'react';

interface IProps {
  options: IOption[];
  handleClear: () => void;
  handleNameSearch: (name: string) => void;
  handleSelect: (id: string, option: IOption) => void;
}

const TechnicalCategoryLookup: React.FC<IProps> = ({
  options,
  handleNameSearch,
  handleClear,
  handleSelect,
}) => {
  return (
    <Select
      allowClear
      showSearch
      notFoundContent={null}
      filterOption={false}
      style={{ width: 500 }}
      options={options}
      onClear={handleClear}
      onSelect={handleSelect}
      onSearch={handleNameSearch}
      placeholder={L('Enter problem part here')}
    />
  );
};

export default TechnicalCategoryLookup;
